import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { setDefaultState } from '../../store/sessionStatus';
import { TotalScoreSVG } from '../../assets/SVGAssets';

import decor1 from '../../assets/images/icon8.webp';

import './totalScore.css';

export default function TotalScore({ score, questionCount }) {
    const dispatch = useDispatch();
    return (
        <Link to={'/'} onClick={() => dispatch(setDefaultState())}>
            <div className="totalScoreWrapper">
                <div className="timeOutBorders">
                    <div className="timeOut-border left"></div>
                    <div className="timeOut-border right"></div>
                </div>

                <div className="totalScoreTitle">
                    <TotalScoreSVG />
                </div>

                <div className="totalScoreContent">
                    <h1>Total Score</h1>

                    <p>You've made it to the end!</p>

                    <h2>
                        Your score is {score}/{questionCount} points
                    </h2>
                </div>

                <img className="decor1" src={decor1} alt="decor" />
            </div>
        </Link>
    );
}
